"use client";

import React, { ReactNode } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { PAGE_TYPE } from "@faire/retailer/consts/PAGE_TYPE";
import { CategoryLayoutElementProductTileClickProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/LayoutElement/CatnavLayoutElementProductTileClickProvider";
import { LayoutElementProductTileClickBaseProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/LayoutElement/HomepageLayoutElementProductTileClickProvider";
import { SearchProductTileClickProviderProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/search/SearchProductTileClickProviderProps";

export const LayoutElementProductTileClickProvider = ({
  data,
  children,
}: {
  data: SearchProductTileClickProviderProps;
  children: ReactNode;
}) => {
  const { pageType } = React.useContext(Context);

  switch (pageType) {
    case PAGE_TYPE.CATEGORY:
      return (
        <CategoryLayoutElementProductTileClickProvider data={data}>
          {children}
        </CategoryLayoutElementProductTileClickProvider>
      );
    default:
      return (
        <LayoutElementProductTileClickBaseProvider data={data}>
          {children}
        </LayoutElementProductTileClickBaseProvider>
      );
  }
};
